// Existing routes plus new one
export const ROUTES = {
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  EMAIL_VERIFIED: "/email-verified",
  PERSONAL_INFO: "/personal-info",
  BUSINESS_INFO: "/business-info",
  PACKAGES: "/packages",
  PLANS: "/plans",
  PREMIUM_USER: "/premium-user",
  PAYMENT: "/payment", // New iframe payment page
  PAYMENT_PROCESSING: "/payment-processing",
  HOME: "/",
  PROFILE: "/profile",
  MY_SCHEDULE: "/schedule",
  MY_PLAYLIST: "/playlist",
  MY_PLAYLIST_EDIT: "/playlist/:id",
  NEW_PLAYLIST: "/new-playlist",
  LIKED: "/liked",
  ARTIST: "/artist",
  ARTIST_DETAIL: "/artist/:id",
};
